const HINTS = [
  { keys: "↑↓", label: "navigate" },
  { keys: "↵", label: "select" },
  { keys: "esc", label: "close" },
] as const;

export function CommandPaletteFooter() {
  return (
    <div className="bg-surface-subtle flex items-center gap-4 border-t border-[#EBEDF2] px-5 py-2">
      {HINTS.map(({ keys, label }) => (
        <div
          key={keys}
          className="text-action-disabled-content flex items-center gap-1 text-[11px]"
        >
          <kbd className="rounded border border-[#EBEDF2] bg-white px-[5px] py-px text-[10px] font-medium text-[#6B7280]">
            {keys}
          </kbd>
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
}
